<template>
  <RoamTransaction
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :formsConfig="formsConfig"
    :backButtonRoute="backButtonRoute"
    :screenJson="getScreenJson"
    :dataModel="dataModelToPass"
    :setLoading="setLoading"
    :saveDisabled="saveDisabled"
    :localDataGrid="false"
    :saveConfigs="saveConfigs"
    :rowClick="rowClickCallBack"
    :validationSummary="validationSummary"
    :barcodeScanned="barcodeScanned"
    :headerConfig="headerConfig"
    :selectedViewValue="selectedViewValue"
    :detailPopUpFormItems="getDetailPopupFormItems"
    :detailPopUpBack="detailPopUpBack"
    :detailPopUpFormVisible="detailPopUpFormVisible"
    :detailPopUpFormDataModel="getDetailPopUpFormDataModel"
    :detailPopUpDataCallBack="detailPopUpDataCallBack"
    :getSelectedViewType="selectedViewType"
    :detailPopUpConfig="detailPopUpConfig"
    :saveRoamTransaction="saveRoamTransaction"
    :saveRoamBtnConfig="{
      icon: undefined,
      text: 'Close',
    }"
    :ref="'roam-product'"
    :serverError="serverError"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import RoamTransaction from "@/templates/roam/roam-transaction.vue";
import { RoamTransactionService } from "../../../_services/api/templates/roam-transactions.services";
import { getDefaultUserSettings } from "../../../_store/helpers";
import { ProductService } from "../../../_services/api/products/product.service";
import { ProductUnitOfMeasureService } from "../../../_services/api/products/product-unit-of-measure.service";
// import { BranchService } from '../../../_services/api/sales/branch.service';
import { BinLocationService } from "../../../_services/api/settings/products/bin-location.service";
import { ProductLocationService } from "../../../_services/api/products/product-location.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: { RoamTransaction },
  watch: {
    detailPopUpFormDataModel: {
      handler(val) {
        if (val && this.detailPopUpFormVisible) {
          if (
            this.selectedViewValue == 2 &&
            this.detailPopUpFormDataModel.BranchCode &&
            this.detailPopUpFormDataModel.LocationCode
          ) {
            this.detailPopUpData.EnableSave = true;
          } else {
            // this.detailPopUpData.EnableSave = false;
          }
        }
      },
      deep: true,
    },
    detailPopUpFormVisible(val) {
      if (val == false) {
        this.editLocation.allocatedLocations = [];
        this.editLocation.data = undefined;
      }
    },
  },
  async created() {
    // this.setLoading = true;
    this.getBinLocation();
  },
  mounted() {},
  data() {
    return {
      allowOverPicking: false,
      backButtonRoute: "/roam-product",
      dataModel: undefined,
      validationSummary: [],
      setLoading: false,
      saveDisabled: {
        header: true,
        detail: true,
        line: false,
        save: false,
      },
      productsList: [],
      saveConfigs: {
        // url: "Save_RoamPickingSlip",
        url: "Save_PickingSlip",
        payload: this.getPayload,
      },

      detailPopUpData: {
        EnableSave: false,
      },
      detailPopUpFormVisible: false,
      detailPopUpFormDataModel: {},
      selectedViewValue: 0,
      selectedViewType: "details",
      viewPoints: [
        { menuText: "Stock", value: 0, type: "details" },
        { menuText: "Barcodes", value: 1, type: "details" },
        { menuText: "Locations", value: 2, type: "details" },
        // { menuText: "Header", value: 3, type: "header" },
      ],
      barCodeDataModel: undefined,
      serverError: {},
      allocatedLocationBranchList: [],
      editLocation: {
        allocatedLocations: [],
        data: undefined,
      },
    };
  },
  computed: {
    detailPopUpConfig() {
      return {
        save: {
          text: "SAVE",
          clickCallback: () => {
            this.detailPopUpSaveCallBack();
          },
          disabled: !this.detailPopUpData.EnableSave,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.detailPopUpBackButtonClick();
          },
        },
        option: {
          title: {
            text: "NONE",
            visible: false,
          },
        },
      };
    },
    headerConfig() {
      return {
        options: {
          multiViewSelect: true,
          addNew: true, // this.selectedViewValue != 0 ? true : false,
          viewPoints: this.viewPoints,
        },
        data: {
          addNew: {
            icon: "plus",
            type: "normal",
            class: "class-a1",
            cssClass: "class-a2",
            onClick: () => {
              this.onClickAddNew();
            },
            visible: this.selectedViewValue != 0 ? true : false,
          },

          multiViewOption: {
            items: this.viewPoints,
            keyExpr: "value",
            valueExpr: "value",
            displayExpr: "menuText",
            value: this.selectedViewValue,
            width: this.isXSmall ? 100 : 150,
            dropDownOptions: {
              minWidth: 105,
            },
            onItemClick: (e) => {
              // console.log("Menu Click ", e);
              e.component.close();
            },
            onValueChanged: (e) => {
              // console.log("On Value Change ", e);
              this.viewChange(e);
            },
          },
        },
      };
      // background-color: #03a9f4 !important;
    },
    dataModelToPass() {
      return this.dataModel;
    },
    getScreenJson() {
      if (this.selectedViewValue == 0) return this.getStockView;
      else if (this.selectedViewValue == 1) return this.getBarcodeView;
      else if (this.selectedViewValue == 2) return this.getLocationView;
      else return this.getStockView;
    },
    getStockView() {
      return {
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              localDataList: false,
              // items: this.productsList,
              endpoint: "StockEnquiryQuantity",
              filter: [["ItemCode", "=", `${this.baseView.id}`]],
              serverPaging: true,
              // allowGrouping: false,
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "hooray",
            //     title: "No Orders",
            //     message:
            //       "Your work is complete, all orders have been despatched.",
            //   },
            // },
            options: {
              pageSize: 50,
              allowedPageSizes: [25, 50, 100],
              wordWrapEnabled: this.isXSmall ? false : true,
              rowSelect: false,
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "Branch",
              cellTemplate: undefined,
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "OnHand",
              gridDataField: "OnHand",
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "Commited",
              gridDataField: "Committed",
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "Available",
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "IncomingOrders",
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "InProduction",
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
          ],
        },
      };
    },
    getLocationView() {
      return {
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              localDataList: false,
              // items: this.productsList,
              endpoint: "ProductLocationList",
              filter: [["ProductCode", "=", `${this.baseView.id}`]],
              serverPaging: true,
              // allowGrouping: false,
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "hooray",
            //     title: "No Orders",
            //     message:
            //       "Your work is complete, all orders have been despatched.",
            //   },
            // },
            options: {
              pageSize: 50,
              allowedPageSizes: [25, 50, 100],
              wordWrapEnabled: this.isXSmall ? false : true,
              // rowSelect: false,
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "Branch",
              cellTemplate: undefined,
              minWidth: this.isXSmall ? "50%" : undefined,
              width: this.isXSmall ? "50%" : undefined,
              sortOrder: "asc",
              sortIndex: 0,
            },
            {
              screenField: "Location",
              gridDataField: "BinLocationLocation",
              minWidth: this.isXSmall ? "50%" : undefined,
              width: this.isXSmall ? "50%" : undefined,
            },

            {
              screenField: "IsDefault",
              gridDataField: "IsDefault",
              cellTemplate: "CheckBoxTemplate",
              makeReadOnly: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.IsDefault == "Y"
                );
              },
              valueChangeCallBack: this.checkBoxValueChange,
            },
          ],
        },
      };
    },
    getBarcodeView() {
      return {
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              localDataList: false,
              // items: this.productsList,
              endpoint: "ProductUnitOfMeasureList",
              filter: [
                ["ProductCode", "=", `${this.baseView.id}`],
                "and",
                ["BranchCode", "=", getDefaultUserSettings().BranchCode],
              ],
              serverPaging: true,
              // allowGrouping: false,
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "hooray",
            //     title: "No Orders",
            //     message:
            //       "Your work is complete, all orders have been despatched.",
            //   },
            // },
            options: {
              pageSize: 50,
              allowedPageSizes: [25, 50, 100],
              // wordWrapEnabled: this.isXSmall ? false : true,
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "UnitOfMeasure",
              gridDataField: "UnitOfMeasureCode",
              cellTemplate: undefined,
              minWidth: this.isXSmall ? "50%" : undefined,
              width: this.isXSmall ? "50%" : undefined,
            },
            {
              screenField: "Location",
              gridDataField: "Barcode",
              label: "Barcode",
              minWidth: this.isXSmall ? "50%" : undefined,
              width: this.isXSmall ? "50%" : undefined,
            },
          ],
        },
      };
    },
    getDetailPopUpFormDataModel() {
      return this.detailPopUpFormDataModel;
    },
    getDetailPopupFormItems() {
      if (this.selectedViewValue == 1) return this.getBarcodeFormItems;
      else return this.getLocationFormItems;
    },
    getBarcodeFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "SalesUMCode",
              label: {
                text: "UM",
              },
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig(
                  "api/ProductUnitOfMeasureList",
                  {
                    filter: [
                      ["ProductCode", "=", this.dataModel.Code],
                      "and",
                      ["BranchCode", "=", getDefaultUserSettings().BranchCode],
                    ],
                  }
                ),
                // itemTemplate: "Record",
                valueExpr: "UnitOfMeasureCode",
                displayExpr: "UnitOfMeasureCode",
                searchExpr: ["UnitOfMeasureCode", "BranchDescription"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                onItemClick: async (e) => {
                  this.salesUMCodeOnItemClick(e);
                },
                onValueChanged: (e) => {
                  this.onSalesUMCodeValueChanged(e);
                },
              },
            },
            {
              dataField: "BarCode",
              label: {
                text: "BarCode",
              },
              editorType: "dxTextBox",
              editorOptions: {
                readOnly: !this.detailPopUpFormDataModel.SalesUMCode,
                onValueChanged: (e) => {
                  this.onBarCodeValueChanged(e);
                },
              },
            },
          ],
        },
      ];
    },
    getLocationFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              screenField: "Branch",
              dataField: "BranchCode",
              label: {
                text: "Branch",
              },
              required: true,
              editorOptions: {
                showClearButton: true,
                onValueChanged: (e) => {
                  this.resetDefault();

                  if (e.value) {
                    this.onLocationBranchChange(e);
                  }
                },
                readOnly: this.editLocation.data ? true : false,
              },
            },

            {
              dataField: "LocationCode",
              label: {
                text: "Location",
              },
              editorType: "dxSelectBox",
              editorOptions: {
                noDataText: this.detailPopUpFormDataModel.BranchCode
                  ? "All available locations have been specified for this branch."
                  : "No data to display",
                dataSource: BinLocationService.dataSourceConfig(
                  "api/BinLocation",
                  {
                    select: ["Location", "Code"],
                    filter: ["Inactive", "=", "N"],
                    sort: [{ selector: "Location", asc: true }],
                    postProcess: (e) => {
                      if (this.editLocation.allocatedLocations.length > 0) {
                        var items = [];
                        e.forEach((element) => {
                          var i = this.editLocation.allocatedLocations.findIndex(
                            (x) => {
                              if (this.editLocation.data)
                                return (
                                  x.BinLocationCode == element.Code &&
                                  x.BinLocationCode !=
                                    this.editLocation.data.BinLocationCode
                                );
                              else return x.BinLocationCode == element.Code;
                            }
                          );
                          if (i == -1) items.push(element);
                        });

                        return items;
                      } else return e;
                    },
                  }
                ),
                valueExpr: "Code",
                searchExpr: ["Location", "Code"],
                searchMode: "contains",
                showClearButton: true,
                // itemTemplate: "binLocation",
                itemTemplate: function(itemData) {
                  return `${itemData.Location} - ${itemData.Code}`;
                },

                searchEnabled: true,
                displayExpr: "Location",
                onValueChanged: () => {
                  this.resetDefault();
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Bin Location is required",
                },
              ],
            },
            {
              dataField: "IsDefault",
              label: {
                text: "Default Flag",
              },
              editorType: "dxCheckBox",

              editorOptions: {
                allowUpdate:
                  this.detailPopUpFormDataModel.BranchCode &&
                  this.detailPopUpFormDataModel.LocationCode
                    ? true
                    : false,
                readOnly:
                  this.editLocation.data &&
                  this.editLocation.data.IsDefault == "Y"
                    ? true
                    : false,

                onValueChanged: (e) => {
                  this.onIsDefaultValueChange(e);
                },
              },
            },
          ],
        },
      ];
    },
  },
  methods: {
    onLocationBranchChange(e) {
      this.setLoading = true;
      this.getBranchLocations(e.value);
    },
    resetDefault() {
      if (!this.editLocation.data) {
        // product location create mode
        this.detailPopUpFormDataModel.IsDefault = false;
      } else if (
        this.editLocation.allocatedLocations &&
        this.editLocation.allocatedLocations.length == 1
      ) {
        // set to true if only one location available
        this.detailPopUpFormDataModel.IsDefault = true;
      } else if (this.editLocation.data.IsDefault !== "Y")
        this.detailPopUpFormDataModel.IsDefault = false;
    },
    onIsDefaultValueChange(e) {
      if (e.value) {
        this.setLoading = true;
        this.checkBranchLocationDefault(
          e,
          {
            BranchCode: this.detailPopUpFormDataModel.BranchCode,
            ProductCode: this.detailPopUpFormDataModel.ProductCode,
          },
          () => {
            this.setLoading = false;
          }
        );
      }
    },
    async checkBoxValueChange(fieldData, recordData) {
      if (recordData.rowType != "header") {
        var data = recordData.data;
        var payload = {
          ProductCode: data.ProductCode,
          BinLocationCode: data.BinLocationCode,
          BranchCode: data.BranchCode,
          RecordId: data.RecordId,
          IsDefault: fieldData.value ? "Y" : "N",
          AllBranches: "N",
        };
        if (fieldData.value) {
          this.setLoading = true;
          this.checkBranchLocationDefault(
            fieldData,
            recordData.data,

            () => {
              this.updateProductLocationDefault("edit", payload);
            }
          );
        } else {
          this.updateProductLocationDefault("edit", payload);
        }
      }
    },
    async checkBranchLocationDefault(fieldData, data, callBack) {
      await ProductLocationService.getDefaultBinLocation(
        data.BranchCode,
        data.ProductCode
      )
        .then(async (res) => {
          if (res.data.value.length > 0) {
            this.setLoading = false;
            let confirmDefault = await this.$confirm(
              "This branch already has another location configured as the Default Location. Do you want to change it?",
              "Validation"
            );
            if (confirmDefault) {
              this.setLoading = true;
              callBack();
            } else {
              fieldData.value = false;
              fieldData.component.beginUpdate();
              fieldData.component.option("value", false);
              fieldData.component.endUpdate();
              this.setLoading = false;
            }
          } else {
            callBack();
          }
        })
        .catch((err) => {
          if (err) this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Server Error",
            time: new Date().getTime(),
          };
        });
    },
    async updateProductLocationDefault(mode, paload) {
      await ProductLocationService.save(mode, paload)
        .then((res) => {
          if (res) this.setLoading = false;

          if (this.detailPopUpFormVisible) {
            this.detailPopUpFormVisible = false;
            this.detailPopUpData.EnableSave = false;
          }
          this.repaintDataGrid();
        })
        .catch((error) => {
          if (error) this.setLoading = false;
          this.serverError = {
            err: error,
            msg: "Default location update failed",
            time: new Date().getTime(),
          };
        });
    },
    onSalesUMCodeValueChanged(e) {
      if (!e.value) this.detailPopUpData.EnableSave = false;
    },
    async salesUMCodeOnItemClick(e) {
      this.barCodeDataModel = e.itemData;
      if (e.itemData.Barcode) {
        if (this.detailPopUpFormDataModel.BarCode == e.itemData.Barcode) return;
        let confirmBarCode = await this.$confirm(
          "This Unit of Measure already has a barcode associated with it. Do you want to change it?",
          "Validation"
        );
        if (!confirmBarCode) {
          this.detailPopUpFormDataModel.BarCode = e.itemData.Barcode;
        }

        if (this.detailPopUpFormDataModel.BarCode)
          this.detailPopUpData.EnableSave = true;
      }
    },
    onBarCodeValueChanged(e) {
      if (!e.value) this.detailPopUpData.EnableSave = false;
      else if (this.detailPopUpFormDataModel.SalesUMCode)
        this.detailPopUpData.EnableSave = true;
    },
    saveRoamTransaction() {
      // eslint-disable-next-line no-console
      console.log("saveRoamTransaction");
    },
    async detailPopUpBackButtonClick() {
      let confirmLeaving = await this.$confirm(
        "Are you sure you want to cancel?",
        "Cancel"
      );

      if (confirmLeaving) {
        this.detailPopUpFormVisible = false;
        this.detailPopUpData.EnableSave = false;
      }
    },
    async detailPopUpSaveCallBack() {
      this.detailPopUpFormVisible = false;
      this.detailPopUpData.EnableSave = false;

      if (this.selectedViewValue == 1) {
        this.setLoading = true;
        await ProductUnitOfMeasureService.save("edit", {
          AllBranches: "Y",
          Barcode: this.detailPopUpFormDataModel.BarCode,
          BranchCode: this.barCodeDataModel.BranchCode,
          ConversionFactor: this.barCodeDataModel.ConversionFactor,
          IsDefault: this.barCodeDataModel.IsDefault,
          ProductCode: this.barCodeDataModel.ProductCode,
          RecordId: this.barCodeDataModel.RecordId,
          StandardCost: this.barCodeDataModel.StandardCost,
          StandardSell: this.barCodeDataModel.StandardSell,
          UnitStandardSell: this.barCodeDataModel.UnitStandardSell,
          UnitOfMeasureCode: this.barCodeDataModel.UnitOfMeasureCode,
        })
          .then((res) => {
            this.setLoading = false;
            if (res) {
              this.detailPopUpFormVisible = false;
              this.detailPopUpData.EnableSave = false;

              var barcodegrid = this.$refs["roam-product"].$refs[
                "roamTransactionGrid-1"
              ][0];
              barcodegrid.gridRepaint();
            }
          })
          .catch((error) => {
            this.setLoading = false;
            if (error) this.displayGenericAlert("Barcode save failed");
          });
      } else if (this.selectedViewValue == 2) {
        this.setLoading = true;

        if (this.editLocation.data) {
          this.updateProductLocationDefault("edit", {
            ProductCode: this.editLocation.data.ProductCode,
            BinLocationCode: this.detailPopUpFormDataModel.LocationCode,
            BranchCode: this.detailPopUpFormDataModel.BranchCode,
            RecordId: this.editLocation.data.RecordId,
            IsDefault: this.detailPopUpFormDataModel.IsDefault ? "Y" : "N",
            AllBranches: "N",
          });
        } else {
          this.updateProductLocationDefault("create", {
            ProductCode: this.detailPopUpFormDataModel.ProductCode,
            BinLocationCode: this.detailPopUpFormDataModel.LocationCode,
            BranchCode: this.detailPopUpFormDataModel.BranchCode,
            // RecordId: data.RecordId,
            IsDefault: this.detailPopUpFormDataModel.IsDefault ? "Y" : "N",
            AllBranches: "N",
          });
        }
      }
    },
    viewChange(e) {
      this.selectedViewValue = e.value;
    },
    onClickAddNew() {
      if (this.selectedViewValue == 1)
        this.detailPopUpFormDataModel = {
          SalesUMCode: undefined,
          BarCode: undefined,
        };

      if (this.selectedViewValue == 2) {
        this.detailPopUpFormDataModel = {
          ProductCode: `${this.baseView.id}`,
          BranchCode: undefined,
          LocationCode: undefined,
          IsDefault: null,
        };
      }
      this.detailPopUpFormVisible = !this.detailPopUpFormVisible;
    },
    async detailsSalesUMPickedQtyValueChange() {
      this.saveDisabled.detail = false;
      this.saveDisabled.line = true;
      this.detailPopUpData.EnableSave = true;
    },
    getBinLocation() {
      RoamTransactionService.getByCode(
        "Product",
        `Code eq '${this.baseView.id}'`
      )
        .then(async (res) => {
          this.dataModel = res.data.value[0];
          this.dataModel["SaveOption"] = undefined;

          this.$store.dispatch(
            "transactionTemplate/setPrimaryLabel",
            this.dataModel.Code
          );

          this.$store.dispatch(
            "transactionTemplate/setSecondaryLabel",
            this.dataModel.Description1
          );

          this.$store.dispatch(
            "transactionTemplate/setTertiaryLabel",
            this.dataModel.UnitOfMeasureCode
          );

          this.setLoading = false;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          if (err)
            // console.log("err", err);
            this.setLoading = false;
        });
    },
    detailPopUpDataCallBack(data) {
      // eslint-disable-next-line no-console
      console.log("detailPopUpDataCallBack", data);
    },
    detailPopUpBack(e) {
      // eslint-disable-next-line no-console
      console.log("detailPopUpBack", e);
    },
    getPayload() {
      return "getPayload";
    },
    updateTertiaryLabel(labelText) {
      this.$store.dispatch("transactionTemplate/setTertiaryLabel", labelText);
    },
    async rowClickCallBack(e) {
      if (e.rowType == "data" && e.column.screenField != "IsDefault") {
        // eslint-disable-next-line no-console
        console.log("rowClickCallBack", e);

        if (this.selectedViewValue == 1) {
          this.detailPopUpFormDataModel = {
            SalesUMCode: e.data.UnitOfMeasureCode,
            BarCode: e.data.Barcode,
          };
          this.barCodeDataModel = e.data;
          this.detailPopUpFormVisible = !this.detailPopUpFormVisible;
        } else if (this.selectedViewValue == 2) {
          this.editLocation.data = e.data;
          this.detailPopUpFormDataModel = {
            BranchCode: e.data.BranchCode,
            LocationCode: e.data.BinLocationCode,
            IsDefault: e.data.IsDefault == "Y" ? true : false,
          };

          this.setLoading = true;
          await this.getBranchLocations(e.data.BranchCode);
          this.detailPopUpFormVisible = !this.detailPopUpFormVisible;
        }
      }
    },

    async getBranchLocations(BranchCode) {
      await ProductLocationService.getCustomData({
        url: "ProductLocationList",
        filter: `BranchCode eq '${BranchCode}' and ProductCode eq '${this.baseView.id}'`,
      })
        .then((res) => {
          this.editLocation.allocatedLocations = res.data.value;
          this.setLoading = false;
        })
        .catch((err) => {
          if (err) this.editLocation.allocatedLocations = [];

          this.setLoading = false;
        });
    },

    async barcodeScanned(barcode) {
      if (barcode) {
        // eslint-disable-next-line no-console
        console.log("barcode", barcode);
        if (this.detailPopUpFormVisible == true && this.selectedViewValue == 1)
          this.detailPopUpFormDataModel.BarCode = barcode;
      }
    },
    repaintDataGrid() {
      var barcodegrid = this.$refs["roam-product"].$refs[
        "roamTransactionGrid-" + this.selectedViewValue
      ][0];
      barcodegrid.gridRepaint();
    },
  },
};
</script>

<style lang="scss"></style>
